import { sumBy } from "lodash-es";
import React from "react";

import { ProductTileModel } from "@api/mappers/products.mapper";

import { ProductBundlePriceComponent } from "./productBundlePrice.component";

type ProductBundlePriceProps = {
    mainProduct: ProductTileModel;
    bundleProducts: Array<ProductTileModel>;
    className?: string;
};

const ProductBundlePrice = ({
    mainProduct,
    bundleProducts,
    className,
}: ProductBundlePriceProps) => {
    const getJoinedPrice = (
        priceExtractor: (
            product: ProductTileModel,
        ) => number | undefined | null,
    ) => {
        const extractPrice = (product: ProductTileModel) =>
            priceExtractor(product) ?? 0;

        return extractPrice(mainProduct) + sumBy(bundleProducts, extractPrice);
    };

    const showStrippedPrice = !!(
        mainProduct.strikethroughPrice ||
        bundleProducts.some(bundleProduct => bundleProduct.strikethroughPrice)
    );

    const strikethroughPrice = showStrippedPrice
        ? getJoinedPrice(
              product => product.strikethroughPrice ?? product.salesPrice,
          )
        : undefined;

    const salesPrice = getJoinedPrice(product => product.salesPrice);

    return (
        <ProductBundlePriceComponent
            className={className}
            showStrippedPrice={showStrippedPrice}
            strikethroughPrice={strikethroughPrice}
            salesPrice={salesPrice}
        />
    );
};

export { ProductBundlePrice };
